<template>
    <div class="row" v-if="form.id">
        <div class="col-md-10">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label" for="enabled_countries">
                        Allow access to website only from:
                    </label>
                    <VueMultiselect
                        :class="hasError('enabled_countries') ? 'is-invalid' : ''"
                        id="enabled_countries"
                        name="enabled_countries"
                        v-model="form.allowed_countries"
                        :options="countries"
                        :multiple="true"
                        :custom-lable="countryLabel"
                        track-by="name"
                        label="name"
                        placeholder="Select countries"
                    >
                    </VueMultiselect>
                    <div class="mt-2">
                        <span class="form-label" style="color: #525f7f; display: block;">
                            If this field is empty, all countries will be allowed.
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12 mt-2 pb-3">
                    <button type="submit" class="btn btn-primary float-end" @click="updateSettings">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import Form from "../helpers/Form.vue";
import Notification from "../helpers/Notification.vue";

export default {
    mixins: [ Form ],
    components: { VueMultiselect },
    data() {
        return {
            form: {},
            countries: [],
        }
    },
    methods: {
        getCountries() {
            axios.get('/api/countries')
                .then(res => {
                    this.countries = res.data;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        getSettings() {
            this.errors = {};
            axios.get('/api/admin/settings?type=firewall')
                .then(res => {
                    this.form = res.data.data;
                }
            );
        },
        updateSettings() {
            this.form.type = 'firewall'
            axios.put('/api/admin/settings-firewall', this.form)
                .then(res => {
                    Notification.methods.success(res.data.message);
                    this.errors = {};
                })
                .catch((error) => {
                    if(error && error.response.status === 422) {
                        this.setErrors(error.response.data.errors);
                    }else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        countryLabel(option) {
            return option.name;
        }
    },
    mounted() {
        this.getCountries();
        this.getSettings();
    }
}

</script>

<style scoped>
.form-label {
    margin-left: 5px;
}
</style>
